export const getIsPageRefreshed = () => {
    if (typeof window !== 'undefined' && window.performance) {
        const navEntries = window.performance.getEntriesByType('navigation');
        return navEntries?.[0]?.type === 'reload';
    }

    return false;
};
